import { Pressable, Text, View } from "react-native";
import useGestionCETStyle, { couleursCET } from "./GestionCET.styles";
import type { DotationEpargnable } from "./GestionCET.types";
import { Quotas } from "../../api/Dotation/types";

// Libellé du solde épargnable d'une dotation (ex : "7 jours", "46 heures 55 minutes")
export const formatDisponible = (dotation: Quotas) => {
    if(dotation.jourHeure !== 2){
        return `${dotation.resteJours ?? 0} jours`;
    }
    const heures = dotation.resteHeures || 0;
    const minutes = dotation.resteMinutes || 0;
    if(!heures && !minutes){
        return '0 heures';
    }
    return [heures ? `${heures} heures` : '', minutes ? `${minutes} minutes` : ''].filter(Boolean).join(' ');
}

// Fond teinté à partir de la couleur de la nature d'absence
export const couleurFond = (hexa?: string) => (
    hexa && /^#[0-9a-fA-F]{6}$/.test(hexa) ? `${hexa}1F` : couleursCET.grey50
)

export default function DotationEpargnable({dotation, selected, dimmed, onPress}: DotationEpargnable){
    const { styles } = useGestionCETStyle();
    const couleur = dotation.natureAbsence?.couleurHexa || couleursCET.grey450;
    return (
        <Pressable
            onPress={() => onPress?.(dotation)}
            style={[
                styles.dotation,
                selected && [styles.dotationSelected, { borderColor: couleur, backgroundColor: couleurFond(couleur) }],
                dimmed && styles.dotationDimmed,
            ]}
        >
            <View style={[styles.dotationBarre, { backgroundColor: couleur }]}/>
            <View style={styles.dotationContenu}>
                <View style={styles.dotationGauche}>
                    <Text style={styles.dotationLabel}>Nature d'absence</Text>
                    <Text style={[styles.dotationValeur, selected && styles.dotationValeurSelected]}>
                        {dotation.natureAbsence?.libelle}
                    </Text>
                </View>
                <View>
                    <Text style={[styles.dotationLabel, styles.rightText]}>Épargnable</Text>
                    <Text style={[styles.dotationValeur, styles.rightText, selected && styles.dotationValeurSelected]}>
                        {formatDisponible(dotation)}
                    </Text>
                </View>
            </View>
        </Pressable>
    )
}
